import React from "react";

import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import Funnel from "@mapmycustomers/shared/types/entity/deals/Funnel";

interface Props {
  funnels: Funnel[]; // empty list = All Funnels
  visibleFunnelIds: Funnel["id"][];
}

const FunnelList: React.FC<Props> = ({ funnels, visibleFunnelIds }) => {
  const intl = useIntl();

  const info =
    funnels
      .filter(({ id }) => visibleFunnelIds.includes(id))
      .map(({ name }) => name)
      .join(", ") ||
    intl.formatMessage({
      id: "map.layer.heatMap.legend.funnels.all",
      defaultMessage: "All Funnels",
      description: "All Funnels filtering label in HeatMap legend on Map page",
    });

  return <Tooltip title={info}>{info}</Tooltip>;
};

export default FunnelList;
